
import { ResultData } from "@nt-portal/common-sdk";

import { TCMBBBEEPoints, TCMBBBEEPointsService } from "@nt-portal/tcm-sdk";
import { ControllerOptions, DataController } from "../../../../types";
import { BaseClientService } from "../../base-client.service";
import { ValidateResult } from "@nt-portal/common-sdk";


export interface TCMBBBEEPointsOptions extends ControllerOptions<TCMBBBEEPoints> {
    hide?: boolean;
}

export const initTCMBBBEEPoints = (obj: Partial<TCMBBBEEPoints>) => {
    let item: TCMBBBEEPoints = {
        statusLevel: obj.statusLevel || 0,
        createdBy: ""
    }
    return item;
}

export class ClientTCMBBBEEPointsService extends BaseClientService implements DataController<TCMBBBEEPoints> {

    private _service: TCMBBBEEPointsService;


    constructor() {
        super();
        this._service = new TCMBBBEEPointsService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }



    public async get(options: TCMBBBEEPointsOptions): Promise<ResultData<TCMBBBEEPoints>> {
        return await this._service.get(this.buildFetchParams(options), this.token,);
    }

    public async getLookup(options: TCMBBBEEPointsOptions): Promise<ResultData<TCMBBBEEPoints>> {

        let fetchParams = this.buildLookupFetchParams(options);
        let data = await this._service.get(fetchParams, this.token);
        return data;

    }

    public async validate(statusLevel: number, id?: string): Promise<ValidateResult> {

        return await this._service.validate(statusLevel, this.token, id)

    }

    public async getById(options: TCMBBBEEPointsOptions): Promise<TCMBBBEEPoints | null> {
        if (options.id) {
            let item = await this._service.getById(options.id, this.token);
            return item;
        }
        return null;
    }
    public async delete(options: TCMBBBEEPointsOptions): Promise<any> {
        if (options.id)
            await this._service.delete(options.id, this.token);
    }
    public async update(options: TCMBBBEEPointsOptions): Promise<TCMBBBEEPoints | TCMBBBEEPoints[] | null> {
        if (options.item && options.item.id)
            return await this._service.update(options.item.id, options.item, this.token)
        return null;
    }
    public async add(options: TCMBBBEEPointsOptions): Promise<TCMBBBEEPoints | TCMBBBEEPoints[] | null> {
        if (options.item)
            return await this._service.add(options.item, this.token)
        return null;
    }


    public async import(options: TCMBBBEEPointsOptions): Promise<any> {
        if (options.file)
            return await this._service.importExcel(options.file, this.token);
    }

    public async export(options: TCMBBBEEPointsOptions): Promise<any> {
        let fetchParams = this.buildLookupFetchParams(options);
        return await this._service.export(this.token, fetchParams, options.filter);
    }

}